import {
  resolveWapiConnectionSignal,
  type tWapiConnectionSignal,
} from 'src/alerts/WapiDisconnection.functions';
import { useAlertCenterContext } from 'src/providers/AlertCenterProvider/AlertCenter.hook';

/**
 * INT-1653 — the WhatsApp API connection signal the menu dot and the Home row
 * show, taken from the live disconnection notice so they always agree with
 * it. Null while the Alert Center is off: then no notice is shown either.
 */
export function useWapiConnectionSignal(): tWapiConnectionSignal {
  const { alerts, areSurfacesEnabled } = useAlertCenterContext();
  return areSurfacesEnabled ? resolveWapiConnectionSignal(alerts) : null;
}
